import { MetaBoxProps } from './metaBox.types';

const MetaBox: (props: MetaBoxProps) => JSX.Element = ({ type, children }) => {
  const colorChooseLookUp = {
    country: 'var(--color-dark-blue-2)',
    year: 'var(--color-dark-green)',
    rating: 'var(--color-dark-grey)',
  };
  return (
    <span
      className={`project-tile-${type}`}
      style={{ backgroundColor: colorChooseLookUp[type] }}
    >
      {children}
    </span>
  );
};

export default MetaBox;
